import { render, staticRenderFns } from "./PersonalAccount.vue?vue&type=template&id=7953df23&scoped=true&"
import script from "./PersonalAccount.vue?vue&type=script&lang=js&"
export * from "./PersonalAccount.vue?vue&type=script&lang=js&"
import style0 from "./PersonalAccount.vue?vue&type=style&index=0&lang=css&"
import style1 from "./PersonalAccount.vue?vue&type=style&index=1&id=7953df23&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7953df23",
  null
  
)

export default component.exports